import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3de03240&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de03240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de03240')) {
      api.createRecord('3de03240', component.options)
    } else {
      api.reload('3de03240', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3de03240&scoped=true", function () {
      api.rerender('3de03240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/ads/index.vue"
export default component.exports